/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AddDistrictDetails.scss';
import fetch from '../../../../../core/fetch';
import { changeLayerStyle } from '../../../../../actions/district';
import ModalAlert from '../../../ModalAlert';

//fetchPgLayersList what is the path

const fastStyleMargin = {
  marginTop: '7px',
};
const StyleButton = {
  marginTop: '20px',
  //textAlign: 'center'
};

class AddDistrictDetails extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      currentLayer: 0,
      isStyleChanged: false,
      newStyleVal: '',
      showModal: false,
      nazwaJednostki: this.props.district && this.props.district.nazwaJednostki,
      nazwaJednostkiSave: this.props.district && this.props.district.nazwaJednostki,
      adres: this.props.district && this.props.district.address,
      gmina: this.props.district && this.props.district.nazwa,
      powiat: '',
      miejscowosc: '',
      ulica: '',
      nrBudynku: '',
      nrLokalu: '',
      focusPowiat: "form-inline has-error",
    };
  }

  onChangeNazwaJednostki = (e) => {
    this.setState({ nazwaJednostki: e.target.value })
    let vvv = false;
    this.state.nazwaJednostki !== this.nazwaJednostkiSave ? vvv = true : vvv = false;
    this.setState({showSaveButton: vvv})
  };
  onClickNazwaJednostki = () => this.setState({ nazwaJednostkiSave: this.state.nazwaJednostki });
  onChangeGmina = (e) => this.setState({ gmina: e.target.value });
  onChangePowiat = (e) => this.setState({ powiat: e.target.value });
  onChangeMiejscowosc = (e) => this.setState({ miejscowosc: e.target.value });
  onChangeUlica = (e) => this.setState({ ulica: e.target.value });
  onChangeNrBudynku = (e) => this.setState({ nrBudynku: e.target.value });
  onChangeNrLokalu = (e) => this.setState({ nrLokalu: e.target.value });
  dismissModal = () => this.setState({ showModal: false });

  render() {
    let inSave;
    if (this.state.powiat !== '' && this.state.miejscowosc !== '' && this.state.nrBudynku !== '') {
      inSave = 'btn btn-danger';
    } else {
      inSave = 'btn btn-danger disabled';
    }

    return this.props.district ? (
      <div className="col-xs-12">
        <div className="row" >
          <div className="form-inline">
            <label htmlFor="nazwa" className="col-xs-5" style={fastStyleMargin}>Nazwa jednostki organizacyjnej</label>
            <input onChange={(e) => this.onChangeNazwaJednostki(e)} value={this.state.nazwaJednostki} name="nazwa" type="text" className="form-control" />
            {this.state.nazwaJednostkiSave !== this.state.nazwaJednostki ? (
              <button style={{ marginLeft: '10px' }} onClick={() => this.onClickNazwaJednostki()} type="button" className="btn btn-danger">Zapisz</button>
            ) : null}
          </div>
        </div>
        <div className="row" style={fastStyleMargin}>
          <div className="form-inline">
            <label htmlFor="warstwa" className="col-xs-5" style={fastStyleMargin}>Gmina</label>
            <input onChange={(e) => this.onChangeGmina(e)} value={this.state.gmina} name="warstwa" type="text" className="form-control" disabled />
          </div>
        </div>
        {this.state.adres ? (
          <div>
            <br />
            <div className="row">
              <div className="form-inline" style={{ borderTop: '1px solid grey', color: 'grey' }}>
                <label htmlFor="adres" className="col-xs-5" style={fastStyleMargin}>Dodawanie adresu:</label>
              </div>
            </div>
            <br />
            <div className="row" style={fastStyleMargin}>
              <div className={this.state.focusPowiat}>
                <label htmlFor="adres" className="col-xs-5" style={fastStyleMargin}>Powiat</label>
                <input placeholder="pole wymagane" name="adres" type="text" className="form-control" onChange={(e) => this.onChangePowiat(e)} value={this.state.powiat} />
                <span className="glyphicon glyphicon-warning-sign form-control" />
              </div>
            </div>
            <div className="row" style={fastStyleMargin}>
              <div className="form-inline">
                <label htmlFor="warstwa" className="col-xs-5" style={fastStyleMargin}>Miejscowość</label>
                <input placeholder="pole wymagane" name="warstwa" type="text" className="form-control" onChange={(e) => this.onChangeMiejscowosc(e)} value={this.state.miejscowosc} />
              </div>
            </div>
            <div className="row" style={fastStyleMargin}>
              <div className="form-inline">
                <label htmlFor="warstwa" className="col-xs-5" style={fastStyleMargin}>Ulica</label>
                <input name="warstwa" type="text" className="form-control" onChange={(e) => this.onChangeUlica(e)} value={this.state.ulica} />
              </div>
            </div>
            <div className="row" style={fastStyleMargin}>
              <div className="form-inline">
                <label htmlFor="warstwa" className="col-xs-5" style={fastStyleMargin}>Numer budynku</label>
                <input placeholder="pole wymagane" name="warstwa" type="text" className="form-control" onChange={(e) => this.onChangeNrBudynku(e)} value={this.state.nrBudynku} />
              </div>
            </div>
            <div className="row" style={fastStyleMargin}>
              <div className="form-inline">
                <label htmlFor="warstwa" className="col-xs-5" style={fastStyleMargin}>Numer lokalu</label>
                <input name="warstwa" type="text" className="form-control" onChange={(e) => this.onChangeNrLokalu(e)} value={this.state.nrLokalu} />
              </div>
            </div>
            <div className="row" style={{ borderBottom: '1px solid grey' }}>
              <div className="form-inline" style={{ textAlign: 'center', margin: '10px' }}>
                <button onClick={() => { this.setState({ adres: false }) }} type="button" className="btn btn-danger">Anuluj</button>
                {'    '}
                <button type="button" className={inSave} >Zapisz</button>
              </div>
            </div>
          </div>
        ) : null}
        {!this.state.adres ? (
          <div style={StyleButton}>
            <button className="btn btn-danger" type="submit" onClick={() => { this.setState({ adres: true }) }}>Dodaj adres</button>
          </div>
        ) : null}

        <div className="row">
          <div className="col-sm-5" />
          <div className="col-sm-2 text-center" >
            <p className="boundingDesc">max.x</p>
          </div>
          <div className="col-sm-5" />
        </div>

        <div className="row">
          <div className="col-sm-3" />
          <div className="col-sm-2 text-center">
            <p className="boundingDesc">min.y</p>
          </div>
          <div className="col-sm-2 text-center">
            <input className="form-control" type="text" value={this.props.district && this.props.district.bbox.maxx} disabled />
          </div>
          <div className="col-sm-2 text-center">
            <p className="boundingDesc">max.y</p>
          </div>
          <div className="col-sm-3" />
        </div>

        <div className="row">
          <div className="col-sm-3" />
          <div className="col-sm-2 text-center">
            <input className="form-control" type="text" value={this.props.district.bbox.miny} disabled />
          </div>
          <div className="col-sm-2 text-center">
            <p className="boundingDesc">min.x</p>
          </div>
          <div className="col-sm-2 text-center">
            <input className="form-control" type="text" value={this.props.district.bbox.maxy} disabled />
          </div>
          <div className="col-sm-3" />
        </div>

        <div className="row">
          <div className="col-sm-5" />
          <div className="col-sm-2 text-center">
            <input className="form-control" type="text" value={this.props.district.bbox.minx} disabled />
          </div>
          <div className="col-sm-5" />
        </div>
      </div>
    ) : null;
  }
}

const mapState = (state) => ({
  districts: state.district.districts,
});

const mapDispatch = {};

const SubObject = connect(mapState, mapDispatch)(AddDistrictDetails);


export default withStyles(s)(SubObject);



// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/AddDistrictDetails/AddDistrictDetails.js